import { render } from "./ActivityOffcanvas.vue?vue&type=template&id=2ba37b05&scoped=true&ts=true"
import script from "./ActivityOffcanvas.ts?vue&type=script&lang=ts"
export * from "./ActivityOffcanvas.ts?vue&type=script&lang=ts"

import "./ActivityOffcanvas.scss?vue&type=style&index=0&id=2ba37b05&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ba37b05"]])

export default __exports__